import ConstTerms from "../../../helpers/ConstTerms";

const SubscApplyReqConst = {
  
  TERMS: [
    { 
      id: 1, 
      key: ConstTerms.PAY_PERSONAL, 
      showinfo: false, 
      checked: false, 
      required: true, 
      label: ConstTerms.getTermsTitle()[ConstTerms.PAY_PERSONAL], 
    },
    // {
    //   id: 2,
    //   key: 'pay_electronic_fin',
    //   showinfo: true,
    //   checked: false,
    //   required: true,
    //   label: "전자금융거래 이용약관 동의(필수)"
    // },
    // {
    //   id: 3,
    //   key: 'pay_personal_info',
    //   showinfo: true,
    //   checked: false,
    //   required: true,
    //   label: "개인정보 수집 및 이용 동의(필수)"
    // },
    // {
    //   id: 4,
    //   key: 'pay_third_party_provide',
    //   showinfo: true,
    //   checked: false,
    //   required: true,
    //   label: "개인정보 3자 제공 및 위탁 동의(필수)"
    // },
  ]

  // ITEM_CARD: {
  //   cvc: {
  //     title: "CVC",
  //     val: "",
  //     validate: "",
  //     func: {
  //       name: "digitsInt",
  //       n: 3,
  //       comparison: "="
  //     }
  //   },
  //   name: {
  //     title: "카드소유자 성명",
  //     val: "",
  //     validate: "",
  //     func: {
  //       name: "eng"
  //     }
  //   },
  //   month: {
  //     title: "",
  //     val: "",
  //     validate: "",
  //     func: {
  //       name: ""
  //     }
  //   },
  //   num: {
  //     title: "카드번호",
  //     val: "",
  //     validate: "",
  //     func: {
  //       name: "digitsInt",
  //       n: 16,
  //       comparison: "="
  //     }
  //   },
  //   pw: {
  //     title: "카드비밀번호",
  //     val: "",
  //     validate: "",
  //     func: {
  //       name: "digitsInt",
  //       n: 2,
  //       comparison: "="
  //     }
  //   },
  //   year: {
  //     title: "",
  //     val: "",
  //     validate: "",
  //     func: {
  //       name: ""
  //     }
  //   },
  // },

};

export default SubscApplyReqConst;